import React, { Component } from 'react';
import WebNav from './Nav';

class App extends Component {
  render() {
    return (
      <div id="wrapper">
        <div id="bg"></div>
        <div id="overlay"></div>
        <div id="main">
          <header id="header">
            <h1>Mitchell DeMarco</h1>
            <p>Full Stack Engineer&nbsp;&bull;&nbsp; Javascript Aficionado&nbsp;&bull;&nbsp; Startup Guru</p>
            <WebNav/>
          </header>
        </div>
      </div>
    );
  }
}

export default App;



/** WEBPACK FOOTER **
 ** ./src/components/App.js
 **/